import styled from '@emotion/styled'

export const ToolsPageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  padding-block: 32px;
`

export const ToolsContentWrapper = styled.div`
  width: 100%;
`

export const ItemsContainer = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  max-width: calc(5 * 150px + 4 * 32px);
  margin: 0 auto;
  gap: 32px;
`

export const ToolItemLabel = styled.p`
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 600;
  color: #000;
  transition: color 0.3s ease;
`

export const ToolItemImage = styled.img`
  display: block;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  max-height: 100px;
  aspect-ratio: 1/1;
  object-fit: contain;
`

export const ToolItemContainer = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 8px;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: #fff7f4;
    border-color: #ffb399;
  }

  &:hover p {
    color: #ff5000;
  }

  &[data-active='true'] {
    background: #fff7f4;
    border-color: #ff5000;
  }

  &[data-active='true'] p {
    color: #ff5000;
  }
`

export const PrimaryButton = styled.button`
  background-color: #ff5000;
  color: #fff;
  border: 1px solid #ff5000;
  border-radius: 4px;
  padding: 5%;
  font-family: 'Open Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  text-align: left;
  text-transform: capitalize;
  min-width: 89px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background-color: #e64f0a;
    border-color: #e64f0a;
  }

  &:disabled {
    background-color: #cccccc;
    border-color: #cccccc;
    cursor: not-allowed;
  }
`

export const SecondaryButton = styled.button`
  background-color: #ededf2;
  color: #292a2e;
  border: 1px solid #ededf2;
  border-radius: 3px;
  padding: 6px 16px;
  font-family: 'Open Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  text-transform: capitalize;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background-color: #d7dce6;
    border-color: #d7dce6;
  }

  &:disabled {
    background-color: #cccccc;
    border-color: #cccccc;
    color: #fff;
    font-weight: 600;
    cursor: not-allowed;
  }
`

export const ButtonRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
`

export const ModalTitle = styled.h2`
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
`
